import { MODULE_NAME } from "../helpers"

export const selectStatus = state => state[MODULE_NAME].status
export const selectAllPermissions = state => state[MODULE_NAME].allPermissions
export const selectRole = state => state[MODULE_NAME].role
